//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoComboboxBasic from './demos/DemoComboboxBasic.vue'
import DemoComboboxDense from './demos/DemoComboboxDense.vue'
import DemoComboboxVariant from './demos/DemoComboboxVariant.vue'
import DemoComboboxMultiple from './demos/DemoComboboxMultiple.vue'
import DemoComboboxClearable from './demos/DemoComboboxClearable.vue'
import DemoComboboxNoDataWithChips from './demos/DemoComboboxNoDataWithChips.vue'
import DemoComboboxAdvanceCustomOptions from './demos/DemoComboboxAdvanceCustomOptions.vue'

// code
import {
  comboboxBasic,
  comboboxDense,
  comboboxVariant,
  comboboxMultiple,
  comboboxClearable,
  comboboxNoDataWithChips,
  comboboxAdvanceCustomOptions,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoComboboxBasic,
    DemoComboboxDense,
    DemoComboboxVariant,
    DemoComboboxMultiple,
    DemoComboboxClearable,
    DemoComboboxNoDataWithChips,
    DemoComboboxAdvanceCustomOptions,
  },
  setup() {
    return {
      codeSnippets: {
        comboboxBasic,
        comboboxDense,
        comboboxVariant,
        comboboxMultiple,
        comboboxClearable,
        comboboxNoDataWithChips,
        comboboxAdvanceCustomOptions,
      },
    }
  },
}
